import Resource from 'vue-resource';
import store from '../store/store';
import jwtService from '../services/jwt.service';
import router from '../router';
/**
 *
 */
export const interceptGuard = Vue => {
  Vue.use(Resource);
  if (process.env.NODE_ENV === 'development') {
    /**
     * Em desenvolvimento o login é o mesmo de produção: não existe mais token
     * fixo no .env. Os dois que existiam (VUE_APP_JWT_TOKEN_SUNR/SYSCOR) tinham
     * expirado em 2021 e, por serem gravados aqui a cada carga da página,
     * substituíam o token real recém-gravado pelo login -- a primeira chamada
     * autenticada voltava 401 e o app mandava para /login.
     *
     * O que sobra aqui é só a configuração de ambiente, e mesmo ela não pode
     * sobrescrever o que o login definiu.
     */
    if (!window.localStorage.getItem('revista.modulo')) {
      window.localStorage.setItem('revista.modulo', process.env.VUE_APP_SYSTEM);
    }
    if (!window.localStorage.getItem('revista.canal')) {
      window.localStorage.setItem('revista.canal', process.env.VUE_APP_CANAL);
    }
    if (process.env.VUE_APP_UF && !window.localStorage.getItem('revista.uf')) {
      window.localStorage.setItem('revista.uf', process.env.VUE_APP_UF);
    }

    Vue.http.interceptors.push((request, next) => {
      // lido a cada request: o token muda quando o login termina
      const token = window.localStorage.getItem('access_token');

      if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
      }

      request.headers.set('Accept', 'application/json');
      next();
    });
  } else {
    Vue.http.interceptors.push((request, next) => {
      next(({ status, data }) => {
        if (status === 401 && data.error === 'invalid_credentials') {
          // window.localStorage.clear();]
          router.push('/login');
        } else if (status === 401 && data.error === 'token_expired') {
          // o modulo "idle" e do idle-vue (sem namespace), nao ha getter aqui
          if (!store.state.idle.isIdle) {
            return jwtService.refreshToken().then(() => Vue.http(request).then(data => data));
          }
          // window.localStorage.clear();
          router.push('/login');
        }
      });
    });
  }
};
